import apollo from 'graphql/apollo';

export default function moveCategoryInputField({ categories, categoryListQuery }) {
  apollo.writeQuery({
    query: categoryListQuery,
    data: { categories },
  });
}
